import Vue from 'vue';
import BasicBlock from '../SmartSuggestBlocks/BasicBlock';
import { SmartSuggestV4 } from '../../../../declarations/request';
import { InteractionBlockTypes } from '../../services/HandleInteractionService';

export enum PromotionStyle {
    IN_SIDEBAR = 'inSidebar',
    ABOVE_PRODUCTS = 'aboveProducts',
    FULL = 'full',
}

const promotion = Vue.component('fl-promotion', {
    template: `
      <div class="fl-w-100 fl-position-relative fl-as-promotion-image-wrapper" v-if="config.blocks.promotion && promotion">
      <img class="fl-as-promotion-image" @click="selectValue(promotion)" :src="promotion.imageUrl"
           :alt="promotion.name">
      </div>
    `,
    inject: ['config', 'assets', 'HandleInteractionService'],
    props: { promotion: Object },
    components: {
        basic: BasicBlock,
    },
    methods: {
        selectValue(selectedPromotion: SmartSuggestV4.Promotion): void {
            void this.HandleInteractionService.byBlock(InteractionBlockTypes.promotion)
                .withUrl(selectedPromotion.name, selectedPromotion.url)
                .trackAndSubmit();
        },
    },
});

export default promotion;
